import React from 'react'
import ApplicationStatus from '../../component/home/checkStatus/ApplicationStatus'


export default function ApplicationStatusContainer() {

    return (
        <div><ApplicationStatus /></div>
    )
}
